import { render } from "./FeedbackModal.vue?vue&type=template&id=7f9e8138"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/dijuno-mobile/dijuno-mobile.pderasapps.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__